module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [_c('h2', [_c('div', [_vm._v(_vm._s(_vm.$t("allStatisticsView.topOrganizations", [_vm.numTop])))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getCurrentSeasonYears()))])]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.allOrganizations.slice(0, _vm.numTop)), function(o, i) {
    return _c('tr', {
      key: o.organizationId,
      class: {
        hilight: o.organizationId === _vm.store.selectedOrganization.organizationId
      }
    }, [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$n(o.totalSponsorshipAmount, "currency")))])])
  }), _vm._v(" "), (_vm.userOrganizationPos >= _vm.numTop) ? _c('tr', [_c('td', [_vm._v("...")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.userOrganizationPos >= _vm.numTop) ? _c('tr', {
    staticClass: "hilight"
  }, [_c('td', [_vm._v(_vm._s(_vm.userOrganizationPos + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userOrganization.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$n(_vm.userOrganization.totalSponsorshipAmount, "currency")))])]) : _vm._e()], 2)])]) : _c('div', [_c('KkSpinner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b344a5b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/AllStatisticsView.vue
// module id = 128
// module chunks = 0